import React from 'react';
import ServiceStackItem from './ServiceStackItem';

const ServicesStack = ({ services = [] }) => {
    return (
        <div className="stack-wrapper in-content-stack">
            <div className="stack-offset"></div>
            <div className="services-stack">
                {services.map((service, index) => (
                    <ServiceStackItem
                        key={index}
                        title={service.title}
                        number={service.number}
                        description={service.description}
                        tags={service.tags}
                        works={service.works}
                        backgroundColor={service.backgroundColor}
                        titleClass={service.titleClass}
                        descriptionClass={service.descriptionClass}
                    />
                ))}
            </div>
        </div>
    );
};

export default ServicesStack;
